/**
 * 條碼工具函數
 * 用於處理條碼和料號的組合與分離
 */

/**
 * 組合條碼和料號
 * @param {string} rawBarcode - 原始條碼
 * @param {string} itemNumber - 料號
 * @returns {string} 組合後的條碼（條碼+料號），如果沒有料號則返回原始條碼
 */
export const combineBarcode = (rawBarcode, itemNumber) => {
  if (!rawBarcode) return '';
  if (!itemNumber) return rawBarcode;
  return `${rawBarcode}${itemNumber}`;
};

/**
 * 從組合條碼中提取原始條碼（移除料號部分）
 * @param {string} combinedBarcode - 組合後的條碼
 * @param {string} itemNumber - 料號
 * @returns {string} 原始條碼
 */
export const extractRawBarcode = (combinedBarcode, itemNumber) => {
  if (!combinedBarcode) return '';
  if (!itemNumber) return combinedBarcode;
  // 如果條碼以料號結尾，移除料號部分
  if (combinedBarcode.endsWith(itemNumber)) {
    return combinedBarcode.slice(0, -itemNumber.length);
  }
  return combinedBarcode;
};

/**
 * 處理樣式條碼陣列：組合條碼和料號
 * @param {string[]} rawBarcodes - 原始條碼陣列
 * @param {string} itemNumber - 料號
 * @returns {string[]} 組合後的條碼陣列
 */
export const combineBarcodeArray = (rawBarcodes, itemNumber) => {
  if (!rawBarcodes || !Array.isArray(rawBarcodes)) return [];
  return rawBarcodes.map(barcode => combineBarcode(barcode, itemNumber));
};

/**
 * 處理樣式條碼陣列：提取原始條碼
 * @param {string[]} combinedBarcodes - 組合後的條碼陣列
 * @param {string} itemNumber - 料號
 * @returns {string[]} 原始條碼陣列
 */
export const extractRawBarcodeArray = (combinedBarcodes, itemNumber) => {
  if (!combinedBarcodes || !Array.isArray(combinedBarcodes)) return [];
  return combinedBarcodes.map(barcode => extractRawBarcode(barcode, itemNumber));
};

/**
 * 檢查條碼是否匹配（同時檢查組合條碼和原始條碼）
 * @param {string} searchTerm - 搜尋字串
 * @param {string} combinedBarcode - 組合後的條碼
 * @param {string} rawBarcode - 原始條碼
 * @returns {boolean} 是否匹配
 */
export const isBarcodeMatch = (searchTerm, combinedBarcode, rawBarcode) => {
  if (!searchTerm) return false;
  const upperTerm = searchTerm.toUpperCase();
  const upperCombined = (combinedBarcode || '').toUpperCase();
  const upperRaw = (rawBarcode || '').toUpperCase();
  return upperCombined.includes(upperTerm) || upperRaw.includes(upperTerm);
};
